import BigNumber from "bignumber.js";
import { isGte } from "./calcNumber";

export const hexValue = (on_chain_hash = "") => {
    let start = "";
    let end = "";
    if (on_chain_hash.length > 12) {
        // 截取前12个字符
        start = on_chain_hash.substr(0, 6);
        // 替换中间部分为 '...'
        end = on_chain_hash.substr(-6);
    }
    return `${start}....${end}`;
};

/**
 *
 * @param email 929105864247720593@uxuy.one  => 929***593@uxuy.one
 * @returns
 */
export const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export function formatEmail(email, endSlot?, len = 3) {
    if (!emailPattern.test(email)) {
        return email;
    }

    const [localPart, domainPart] = email.split("@");

    let formattedLocalPart;
    if (localPart.length <= len) {
        // formattedLocalPart = '*'.repeat(localPart.length)
        formattedLocalPart = localPart;
    } else {
        const start = localPart.substring(0, 3);
        const end = localPart.substring(localPart.length - 3);
        // formattedLocalPart = `${start}***${endSlot ?? end}`
        formattedLocalPart = `${start}***`;
    }

    return `${formattedLocalPart}@${domainPart}`;
}
export const formatAddress = (
    str = "",
    start = 6,
    end = 6,
    len?: number,
    forceFormat?: boolean,
    slotText?
) => {
    if (!str) return "";
    // const enabledFormat = forceFormat || str?.indexOf('@') === -1
    // if (!enabledFormat) return str

    if (emailPattern.test(str)) {
        return formatEmail(str);
    }

    str = str || "";
    const defaultLen = len ? len : 20;
    if (str?.length < defaultLen) {
        return str;
    }
    return `${str.substring(0, start)}${slotText || "..."}${str.substr(0 - end)}`;
};
/** 区别是   邮箱只保留 前三位 */

export const formatRecordAddress = (str = "", start = 6, end = 6) => {
    if (emailPattern.test(str)) {
        if (str.length < 16) return str;

        return formatAddress(str, 4, 4, 16);
    }

    return formatAddress(str, start, end);
};

export function countLeadingZeros(value: string): number {
    const match = value.match(/\.0+/);
    if (match) {
        return match[0].length - 1; // 减去小数点的长度
    }
    return 0;
}
export function lengthUpToDot(value: string): number {
    const dotIndex = value.indexOf(".");
    if (dotIndex !== -1) {
        return dotIndex + 1; // 包括小数点本身
    }
    return value.length; // 如果没有小数点，返回整个字符串长度
}
function getStringUpToDotZero(value: string): string {
    const match = value.match(/^.*?\.0/);
    if (match) {
        return match[0];
    }
    return ""; // 如果没有匹配到 `.0`，返回空字符串
}


export function formatPriceToValue(
    value: number | string,
    options: { len8?: boolean; prefix?: string; needFormat?: boolean } = {}
): string {
    let { len8 = false, prefix = "$", needFormat = true } = options;
    if (isNaN(Number(value))) {
        value = 0;
    }

    const bigNumberValue = new BigNumber(value);
    if (bigNumberValue.isNegative()) {
        prefix = `-${prefix}`;
    }

    const d = bigNumberValue.abs();
    let result = "";

    if (d.isGreaterThanOrEqualTo(1)) {
        // 对于大于等于1的值，保留两位小数
        result = d.toFormat(len8 ? 2 : 2);
    } else if (d.isEqualTo(0)) {
        result = "0.00";
    } else {
        // 对于小于1的值，处理为特定的格式
        const strVal = BigNumber(d.toPrecision(3)).toFixed().toString();
        const zeroCount = countLeadingZeros(strVal);
        const strUpToDotZero = getStringUpToDotZero(strVal);
        const upToDotCount = lengthUpToDot(strVal);

        result =
            zeroCount >= 4 && strVal.length >= zeroCount
                ? `${strUpToDotZero}{${zeroCount}}${strVal.substring(zeroCount + upToDotCount)}`
                : strVal;
    }

    // 检查是否包含小数点
    if (result.includes(".")) {
        // 分离小数和整数部分
        const parts = result.split(".");
        // 确保小数部分保留至少两位
        while (parts[1].length > 2 && parts[1].endsWith("0")) {
            parts[1] = parts[1].substring(0, parts[1].length - 1);
        }
        result = `${parts[0]}.${parts[1]}`;
    }

    if (!needFormat) return `${prefix}${result}`;
    return `${prefix}${result}`.split("").join("\u200B");
}

export function formatInputDecimal(
    value: string,
    options: {
        maxDecimal?: number;
    }
) {
    const maxEffectiveDecimal = Math.min(options.maxDecimal || 8, 8);
    if (!value) return "0";

    value = value.replace(/[^0-9.]/g, "");

    // 如果输入的第一个字符是小数点，添加前置0
    if (value.startsWith(".")) {
        value = "0" + value;
    } else if (value.startsWith("0") && !value.startsWith("0.")) {
        value = value.replace(/^0+/, "");
    }

    // 防止输入多个小数点
    const parts = value.split(".");
    if (parts.length > 2) {
        value = value.slice(0, value.length - 1); // 移除最后一个字符
    }
    const isDecimal = value.split(".").length > 1;
    if (isDecimal) {
        const decimalPart = parts[1] || "";
        if (decimalPart.length > maxEffectiveDecimal) {
            value = truncateDecimals(value, maxEffectiveDecimal);
        }
    }

    return value;
}
function truncateDecimals(value: string, maxDecimalPlaces: number = 8): string {
    const dotIndex = value.indexOf("."); // 找到小数点的位置
    if (dotIndex !== -1) {
        const integerPart = value.slice(0, dotIndex + 1); // 包括小数点在内的整数部分
        const decimalPart = value.slice(
            dotIndex + 1,
            dotIndex + 1 + maxDecimalPlaces
        ); // 截取小数点后 maxDecimalPlaces 位
        return integerPart + decimalPart;
    }
    return value; // 如果没有小数点，返回原始字符串
}

export const formatInputThousand = (value: string) => {
    try {
        const parts = value.split(".");
        const isDecimal = value.split(".").length > 1;
        if (parts.length > 2) {
            value = value.slice(0, value.length - 1); // 移除最后一个字符
        }

        let integerPart = parts[0].replace(/\D/g, ""); // 去除非数字字符
        const decimalPart = parts[1] || "";

        // 使用Intl.NumberFormat格式化整数部分
        if (integerPart) {
            integerPart = new Intl.NumberFormat("en-US").format(
                parseInt(integerPart)
            );
        }

        // 组合整数部分和小数部分
        value = isDecimal ? `${integerPart}.${decimalPart}` : integerPart;
        return value;
    } catch (error) {
        return value;
    }
};
//转千分位
export const formatThousand = (num: number | string) => {
    try {
        if (isGte(num, 1)) {
            const formatter = new Intl.NumberFormat("en-US", {
                // maximumSignificantDigits: 15,
            });
            return formatter.format(num);
        } else {
            return num;
        }
    } catch (error) {
        return num;
    }
};

export const formatRate = (rate: string | number, options?: any) => {
    options = options || {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
        minimumIntegerDigits: 1,
    };
    try {
        rate = rate || 0;
        const formatter = new Intl.NumberFormat("en-US", {
            minimumIntegerDigits: options?.minimumIntegerDigits || 1,
            maximumFractionDigits: options?.maximumFractionDigits || 5,
            minimumFractionDigits: options?.minimumFractionDigits,
            // maximumSignificantDigits: 2
        });
        // @ts-ignore
        return formatter.format(rate);
    } catch (error) {
        return rate;
    }
};
export const sub = (s, start, end) => {
    if (s.length < end) end = s.length;
    return s.substring(start, end);
};

export const commas = (val) => {
    let [int, decimal] = val.toString().split(".");
    int = int.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    decimal = decimal ? "." + decimal : "";
    return `${int}${decimal}`;
};

export const formatValueFixed = (
    value: number | string,
    decimalDigits: number = 6
): string => {
    const stringValue = BigNumber(value).toFixed();

    if (stringValue.includes(".")) {
        // 分离小数和整数部分，确保小数部分至少保留指定的小数位
        const parts: string[] = stringValue.split(".");
        if (parts[1].length > decimalDigits) {
            parts[1] = parts[1].substring(0, decimalDigits);
        }
        // 合并整数和小数部分，并去掉尾部无效的零
        return `${parts[0]}.${parts[1]}`.replace(/\.?0+$/, "");
    } else {
        return stringValue;
    }
};

export const formatFixed = (val, rate = 2) => {
    const r = BigNumber(val || 0).toFixed(rate);
    return r;
};

export const formatRateSplit = (rate?: number | string, options?: any) => {
    const value = formatRate(rate, options);
    return String(value || "").split(".");
};


export const formatInteger = (num: any, emptyText = "0", decimal = 1) => {
    num = Number(num || 0);
    if (!num) {
        return emptyText;
    }
    if (typeof num !== "number" && num.indexOf(",") !== -1) {
        num = num.replace(/,/g, "");
    }
    // 如果有小数点，且小数点后面有值，则保留小数点后面的值 decimal 位
    if (decimal > 0 && new BigNumber(num).decimalPlaces() > 0) {
        // num = (new BigNumber(num)).decimalPlaces(decimal).toNumber();
        const number = new BigNumber(num);

        const multiplier = new BigNumber(10).pow(decimal);
        num = number
            .multipliedBy(multiplier)
            .integerValue(BigNumber.ROUND_DOWN)
            .dividedBy(multiplier)
            .toNumber();
    }
    return num.toLocaleString(); // 使用内置的 toLocaleString 方法格式化整数
};

/** 格式化剩余时间 */
export function formatRemainTime(time?: number) {
    // 当初始化时间为 undefined 时返回
    if (time === void 0) return "";
    const addZero = (n: number) => (n >= 10 ? n : "0" + n);
    const timeArr: { s: string; t: number }[] = [
        // {s: '天', t: 86400},
        // {s: '时', t: 3600},
        // {s: '分', t: 60},
        // {s: '秒', t: 1},
        // {s: ':', t: 86400},
        { s: ":", t: 3600 },
        { s: ":", t: 60 },
        { s: "", t: 1 },
    ];
    time = Math.ceil(time / 1000);
    let res = "";
    for (let i = 0; i < timeArr.length - 1; i++) {
        const item = timeArr[i];
        if (time >= item.t) {
            const tartget = ~~(time / item.t);
            res += (!i ? tartget : addZero(tartget)) + item.s;
            time %= item.t;
        } else {
            res += "00" + item.s;
        }
    }

    // console.log('format:', res)
    res += addZero(~~time) + timeArr.at(-1)!.s;
    return res;
}

export function formatK(num: number | string): string {
    const value = Number(num);

    if (isNaN(value)) {
        return String(num); // 如果不能转换为数字，直接返回字符串形式
    }

    if (value >= 1000) {
        const fValue = Math.floor(value / 1000); // 使用 Math.floor 更加语义化
        return `${fValue}K`;
    }

    return value.toString();
}

export function formatDate(inputSeconds: string, showYear = true) {
    // 创建一个 Date 对象
    const date = new Date(parseInt(inputSeconds) * 1000);

    // 获取年、月、日、小时、分钟、秒
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    // 返回格式化的字符串
    return `${showYear ? year + "-" : ""}${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function formatDateOnly(inputSeconds: string) {
    // 创建一个 Date 对象
    const date = new Date(parseInt(inputSeconds) * 1000);

    // 获取年、月、日、小时、分钟、秒
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始
    const day = String(date.getDate()).padStart(2, "0");

    // 返回格式化的字符串
    return `${year}-${month}-${day}`;
}
